/**
 * F2 checklist — compressão de foto NO APARELHO antes do upload (celular de
 * chantier tira fotos de 3–8 MB; o endpoint aceita ~3 MB de base64).
 * Redimensiona para no máx. 1600px no maior lado e reencoda JPEG ~0.72.
 * Retorna data URL (`data:image/jpeg;base64,...`).
 */
export async function compressImageToBase64(file: File, maxDim = 1600, quality = 0.72) {
  const dataUrl = await new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = () => reject(new Error("read_failed"));
    reader.readAsDataURL(file);
  });
  const img = await new Promise<HTMLImageElement>((resolve, reject) => {
    const el = new Image();
    el.onload = () => resolve(el);
    el.onerror = () => reject(new Error("decode_failed"));
    el.src = dataUrl;
  });
  const scale = Math.min(1, maxDim / Math.max(img.width, img.height));
  if (scale === 1 && file.size < 1_500_000) return dataUrl; // já pequena
  const canvas = document.createElement("canvas");
  canvas.width = Math.max(1, Math.round(img.width * scale));
  canvas.height = Math.max(1, Math.round(img.height * scale));
  const ctx = canvas.getContext("2d");
  if (!ctx) return dataUrl;
  ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
  return canvas.toDataURL("image/jpeg", quality);
}
